<template>
  <b-container fluid>
    <loading :active.sync="isLoading" color="#00AB63"></loading>
    <b-row>
      <b-col sm="5">
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Agregar ciudad</h4>
          <div class="media text-muted pt-3">
            <b-form @submit.prevent="registrar()" v-if="show" style="width: 100%;">
              <b-row>
                <b-col sm="12">
                  <b-form-group label="Nombre">
                    <b-form-input v-model="form.Nombre" type="text" required placeholder="Nombre"/>
                  </b-form-group>
                  <b-form-group label="Estado">
                    <b-form-select v-model="form.estado" :options="estados" required />
                  </b-form-group>
                  <b-form-group label="Generación">
                    <b-form-input
                      v-model="form.Generacion"
                      type="number"
                      step="0.01"
                      min="0"
                      placeholder="Generación"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="12">
                  <b-form-group label="Seleccione tarifas de la ciudad">
                    <b-form-checkbox-group
                      id="checkbox-group-1"
                      v-model="form.Tarifas"
                      :options="list_tarifas"
                      name="flavour-1"
                      :required="checkbox_add"
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button class="float-right boton_createch" type="submit" variant="primary">
                <i class="far fa-save"></i> Guardar
              </b-button>
            </b-form>
          </div>
        </div>
      </b-col>
      <b-col sm="7">
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Ciudades</h4>
          <div class="media text-muted pt-3">
            <b-container fluid>
              <!-- Main table element -->
              <b-table
                show-empty
                small
                style
                stacked="md"
                :items="ciudades"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
              >
                <template v-slot:cell(tariffs)="data">
                  <span v-for="tarifa in data.item.tariffs" :key="tarifa.id">&nbsp;{{tarifa.name}}</span>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button
                    size="sm" 
                    @click="eliminar(row.item, $event)"
                    class="float-right btn_borrar"
                  >
                    <i class="far fa-trash-alt"></i>
                  </b-button>
                  <b-button 
                    size="sm"
                    @click="editar(row.item,$event)"
                    class="float-right mr-1 btn_editar"
                  >
                    <i class="far fa-edit"></i>
                  </b-button>
                </template>
              </b-table>
              <b-container>
                <b-row class="justify-content-end">
                  <b-col>
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-container>

              <!-- Info modal -->
              <b-modal
                :id="infoModal.id"
                :title="infoModal.title"
                @ok="eliminarTarifa(infoModal.eliminar)"
                centered
                ok-title="Eliminar"
                cancel-title="Cancelar"
              >
                <p
                  style="text-align:center; font-size:25px; font-weight:bold;"
                >¿Está seguro que desea eliminar?</p>
              </b-modal>
              <!-- Editar modal -->
              <b-modal :id="editModal.id" :title="editModal.title" centered hide-footer>
                <b-container>
                  <b-row>
                    <b-form @submit.prevent="actualizar()" v-if="show" style="width: 100%;">
                      <b-row>
                        <b-col sm="12">
                          <b-form-group label="Nombre">
                            <b-form-input
                              v-model="editModal.new.Nombre"
                              type="text"
                              required 
                              placeholder="Nombre"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col sm="12">
                          <b-form-group label="Estado">
                            <b-form-select
                              v-model="editModal.new.estado"
                              :options="estados"
                              required
                            />
                          </b-form-group>
                        </b-col>
                        <b-col sm="12">
                          <b-form-group label="Generacion">
                            <b-form-input
                              v-model="editModal.new.Generacion"
                              type="text"
                              placeholder="Generacion"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col sm="12">
                          <b-form-group label="Tarifas:">
                            <b-form-checkbox-group
                              v-model="editModal.new.Tarifas"
                              :options="list_tarifas"
                              :required="checkbox_edit"
                            ></b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <hr />
                      <b-row>
                        <b-col>
                          <b-button
                            variant="primary"
                            size="sm"
                            type="submit"
                            class="float-right"
                          >Editar</b-button>
                          <b-button
                            variant="secondary"
                            size="sm"
                            class="float-right mr-1"
                            @click="ocultaModal(editModal.id)"
                          >Cancelar</b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                  </b-row>
                </b-container>
              </b-modal>
            </b-container>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<style>
</style>
<script>
import axios from "axios";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading
  },
  data() {
    return {
      isLoading: true,
      ciudades: [],
      list_tarifas: [],
      select_tarifas: [],
      checkbox_add: true,
      checkbox_edit: true,
      fields: [
        { key: "name", sortable: true, label: "Nombre" },
        { key: "generate", sortable: true, label: "Generación" },
        { key: "tariffs", sortable: true, label: "Tarifas" },
        { key: "actions", label: "", thStyle: { width: "20%" } }
      ],
      estados: [
        { text: "Selecciona estado", value: null },
        { text: "Aguascalientes", value: "Aguascalientes" },
        { text: "Baja California", value: "Baja California" },
        { text: "Baja California Sur", value: "Baja California Sur" },
        { text: "Campeche", value: "Campeche" },
        { text: "Chiapas", value: "Chiapas" },
        { text: "Chihuahua", value: "Chihuahua" },
        { text: "Coahuila", value: "Coahuila" },
        { text: "Colima", value: "Colima" },
        { text: "CDMX", value: "CDMX" },
        { text: "Durango", value: "Durango" },
        { text: "Estado de México", value: "Estado de México" },
        { text: "Guanajuato", value: "Guanajuato" },
        { text: "Guerrero", value: "Guerrero" },
        { text: "Hidalgo", value: "Hidalgo" },
        { text: "Jalisco", value: "Jalisco" },
        { text: "Michoacán", value: "Michoacán" },
        { text: "Morelos", value: "Morelos" },
        { text: "Nayarit", value: "Nayarit" },
        { text: "Nuevo León", value: "Nuevo León" },
        { text: "Oaxaca", value: "Oaxaca" },
        { text: "Puebla", value: "Puebla" },
        { text: "Querétaro", value: "Querétaro" },
        { text: "Quintana Roo", value: "Quintana Roo" },
        { text: "San Luis Potosí", value: "San Luis Potosí" },
        { text: "Sinaloa", value: "Sinaloa" },
        { text: "Sonora", value: "Sonora" },
        { text: "Tabasco", value: "Tabasco" },
        { text: "Tamaulipas", value: "Tamaulipas" },
        { text: "Tlaxcala", value: "Tlaxcala" },
        { text: "Veracruz", value: "Veracruz" },
        { text: "Yucatán", value: "Yucatán" },
        { text: "Zacatecas", value: "Zacatecas" }
      ],
      show: true,
      form: {
        Nombre: "",
        Generacion: null,
        Tarifas: [],
        estado: null
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      infoModal: {
        id: "info-modal",
        title: "",
        eliminar: ""
      },
      editModal: {
        id: "edit-modal",
        title: "",
        new: {
          Nombre: "",
          Generacion: null,
          estado: null,
          _id: null,
          Tarifas: []
        }
      }
    };
  },
  watch: {
    "form.Tarifas": function(newValue, old) {
      if (newValue.length > 0) {
        this.checkbox_add = false;
      } else {
        this.checkbox_add = true;
      }
    },
    "editModal.new.Tarifas": function(newValue, old) {
      if (newValue.length > 0) {
        this.checkbox_edit = false;
      } else {
        this.checkbox_edit = true;
      }
    }
  },
  methods: {
    registrar() {
      this.isLoading = true;
      axios
        .post("cities", {
          name: this.form.Nombre,
          generate: this.form.Generacion,
          estate: this.form.estado,
          tariffs: this.form.Tarifas
        })
        .then(res => {
          if (res.status === 202) {
            this.makeToast("Ya existe un ciudad con ese nombre", "Ciudad");
            this.isLoading = false;
          } else {
            this.resetForm();
            this.listar();
            this.isLoading = false;
          }
        })
        .catch(error => {
          if (error.response.status === 400) {
            this.makeToast("Verifica los datos de la ciudad.", "Ciudad");
            this.isLoading = false;
          } else {
            this.makeToast("Ocurrió un error inesperado.", "Error");
            this.isLoading = false;
          }
        });
    },
    eliminarTarifa(city_id) {
      this.isLoading = true;
      axios
        .delete("city/" + city_id)
        .then(res => {
          this.resetDeleteModal();
          this.listar();
        })
        .catch(error => {
          this.makeToast("Ocurrió un error inesperado.", "Error");
          this.isLoading = false;
        });
    },
    actualizar() {
      this.isLoading = true;
      axios
        .put("city/" + this.editModal.new._id, {
          name: this.editModal.new.Nombre,
          generate: this.editModal.new.Generacion,
          estate: this.editModal.new.estado,
          tariffs: this.editModal.new.Tarifas
        })
        .then(res => {
          if (res.status === 202) {
            this.makeToast("Ya existe un ciudad con ese nombre", "Ciudad");
          } else {
            this.resetEditModal();
            this.listar();
            this.ocultaModal(this.editModal.id);
            this.isLoading = false;
          }
        })
        .catch(error => {
          if (error.response.status === 400) {
            this.makeToast("Verifica los datos de la ciudad.", "Ciudad");
            this.ocultaModal(this.editModal.id);
            this.isLoading = false;
          } else {
            this.makeToast("Ocurrió un error inesperado.", "Error");
            this.ocultaModal(this.editModal.id);
            this.isLoading = false;
          }
        });
    },
    eliminar(item, button) {
      this.resetDeleteModal();
      this.infoModal.title = `Eliminar ciudad: ${item.name}`;
      this.infoModal.eliminar = item._id;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    editar(item, button) {
      this.resetEditModal();
      this.editModal.new.Nombre = item.name;
      this.editModal.new.estado = item.estate;
      this.editModal.new.Generacion = item.generate;
      this.editModal.new._id = item._id;
      let elements = [];
      item.tariffs.map(element => {
        elements.push(element._id);
      });
      this.editModal.new.Tarifas = elements;
      this.editModal.title = `Editar ciudad: ${this.editModal.new.name}`;
      this.$root.$emit("bv::show::modal", this.editModal.id, button);
    },
    listar() {
      let me = this;
      this.isLoading = true;
      axios
        .get("cities")
        .then(res => {
          if (res.data) {
            this.totalRows = res.data.length;
            this.ciudades = res.data;
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.makeToast(
            "Ocurrió un error al consultar las ciudades.",
            "Error"
          );
          this.isLoading = false;
        });
    },
    tarifas() {
      this.isLoading = true;
      axios
        .get("tariffs")
        .then(res => {
          if (res.data) {
            res.data.map(tar => {
              this.list_tarifas.push({ text: tar.name, value: tar._id });
            });
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.makeToast("Ocurrió un error al consultar las tarifas.", "Error");
          this.isLoading = false;
        });
    },
    ocultaModal(id) {
      this.$bvModal.hide(id);
    },
    resetForm() {
      this.form = {
        Nombre: "",
        Generacion: null,
        Tarifas: [],
        estado: null
      };
    },
    resetEditModal() {
      this.editModal = {
        id: "edit-modal",
        title: "",
        new: {
          Nombre: "",
          Generacion: null,
          estado: null,
          _id: null,
          Tarifas: []
        }
      };
    },
    resetDeleteModal() {
      this.infoModal = {
        id: "info-modal",
        title: "",
        eliminar: ""
      };
    }
  },
  created() {
    this.tarifas();
    this.listar();
  }
};
</script> 